/* eslint-disable */
import React from "react";
import { RootState } from "Store/mainStore";
import { useSelector, useDispatch } from "react-redux";
import Tabs, { Tab } from "@nokia-csf-uxr/ccfk/Tabs";
import { setSelectedTab } from "Store/contentState/commonSlice";

const ARIA_LABEL_TEXT_1 = 'To select Tab ';
const ARIA_LABEL_TEXT_2 = ' press spacebar';

const CommonOrdersTab: React.FC = () => {
    const dispatch = useDispatch();
    const { selectedTab } = useSelector((state: RootState) => state.common.commonOrderTabDetails);
    const tabData = useSelector((state: RootState) => state.common.commonOrderTabDetails.tabData);

    const handleTabSelect = (id: number, children: string) => {
        console.log("handleTabSelect", id, children);
        dispatch(setSelectedTab({ id, children }));
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Tabs alignment="left" fullWidth={false} variant="default">
                    {tabData.map(({ tab }, i) => {
                        const ariaMainText = tab && tab.label;
                        return (
                            <Tab
                                id={`tab-${i}`}
                                aria-label={selectedTab === i ? `${ariaMainText}` : `${ARIA_LABEL_TEXT_1} ${ariaMainText} ${ARIA_LABEL_TEXT_2} `}
                                aria-controls={`tab-content-${i}`}
                                aria-posinset={(tab && tab.label) ? i + 1 : undefined}
                                aria-setsize={(tab && tab.label) ? tabData.length : undefined}
                                role="option"
                                key={`tab-${i}`}
                                selected={selectedTab === i}
                                onSelect={() => handleTabSelect(i, tab.children)}
                                {...tab}
                                children={tab.children}
                            />
                        );
                    })}
                </Tabs>
            </div>
        </>
    )
}

export default CommonOrdersTab;
